import styled from 'styled-components'

export const LandingBackground = styled.div`
	background-color: #FFF9EE;
`